<input matInput preventSpace
    (blur)="blurHandler()"
    (keyup)="keyup()"
    (keyup.enter)="keyup()"
    (input)="change()"
    [disabled]="disabled || readonly"
    [(ngModel)]="value"
    type="number"
    [placeholder]="placeholder"
    onkeypress="return /[0-9 .]/i.test(event.key)"
/>
